"use client";

import { useFaireProtection } from "@faire/retailer-visitor-shared/stores/domain/FaireProtection/useFaireProtection";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";
import React from "react";

import { NotifyMeBackInStockButton } from "./NotifyMeButton";
import { NotifyMeProps } from "./NotifyMeProps";

interface IProps {
  data: NotifyMeProps;
}

export const NotifyMe: React.FC<IProps> = ({ data }) => {
  const isSalesPaused = data.productState === IProduct.State.SALES_PAUSED;
  const { isBrandTokenForbidden } = useFaireProtection();
  const isFaireProtectionRestricted = isBrandTokenForbidden(
    data.brandToken ?? ""
  );

  if (
    !isSalesPaused ||
    data.productOptionToken === undefined ||
    isFaireProtectionRestricted
  ) {
    return null;
  }
  return (
    <NotifyMeBackInStockButton
      productOptionToken={data.productOptionToken}
      productToken={data.productToken}
      productState={data.productState}
      isSubscribedToBackInStockNotification={
        data.isSubscribedToBackInStockNotification
      }
      brandToken={data.brandToken}
    />
  );
};
